import { render } from "./MyBalance.vue?vue&type=template&id=40672bb3&scoped=true"
import script from "./MyBalance.vue?vue&type=script&lang=js"
export * from "./MyBalance.vue?vue&type=script&lang=js"

import "./MyBalance.vue?vue&type=style&index=0&id=40672bb3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40672bb3"]])

export default __exports__